import { useEffect, useState } from "react";

const useSpotifyAlbumsData = (
  spotifyToken,
  requestUrl,
  searchQ,
  loadingSetter
) => {
  const [albums, setAlbums] = useState([]);

  const removeDuplicates = (data, propertyName) => {
    const flag = {};
    const unique = [];

    data.forEach((elem) => {
      if (!flag[elem[propertyName]]) {
        flag[elem[propertyName]] = true;
        unique.push(elem);
      }
    });

    return unique;
  };

  async function getAlbums() {
    const dataParameters = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${spotifyToken}`,
      },
    };

    const dataResults = await fetch(requestUrl, dataParameters)
      .then((response) => response.json())
      .then((data) => {
        const filteredAlbums = data.albums.items.filter(
          (item) => item.album_type === "album"
        );

        const uniqueAlbums = removeDuplicates(filteredAlbums, "name");

        const finalAlbums = uniqueAlbums.map((album) => ({
          mainArtist: album.artists[0].name,
          id: album.id,
          img: album.images[0].url,
          url: album.external_urls.spotify,
          name: album.name,
        }));

        window.sessionStorage.setItem("AlbumData", JSON.stringify(finalAlbums));

        setAlbums(finalAlbums);

        loadingSetter(false);
      });

    console.log(dataResults);
  }

  useEffect(() => {
    if (searchQ.length > 0) {
      getAlbums();
    }
  }, [searchQ]);

  return { albums, setAlbums };
};

export default useSpotifyAlbumsData;
